const clone = function (input) {
  return JSON.parse(JSON.stringify(input))
}

export default clone
